module.exports = __webpack_public_path__ + "img/support.9013a79c.svg";